export function formatDuration(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const remainingMinutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  // form the string
  let result = '';

  if (hours > 0) {
    result += `${hours}h `;
  }

  if (remainingMinutes > 0) {
    result += `${remainingMinutes}m `;
  }

  if (remainingSeconds > 0 || (remainingMinutes === 0 && hours === 0)) {
    result += `${remainingSeconds}s`;
  }

  // trim extra spaces on the right
  return result.trim();
}
